import React, { Fragment, useEffect, useState } from "react";
import { Button, Modal, ModalBody, ModalHeader } from "reactstrap";

// redux toolkit
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { resendAgreementSms } from "../../slices/apps/agreementSlice";

// data dosyaları
import Question from "../../assets/images/question.png";

const AgreementSmsModal = ({ id, isOpen, toggle }) => {
  const dispatch = useDispatch();

  // states
  const { resendAgreementSmsLoading } = useSelector((state) => {
    return {
      resendAgreementSmsLoading: state.agreement.resendAgreementSmsLoading,
    };
  }, shallowEqual);

  const sendSMS = async () => {
    try {
      const resultAction = await dispatch(resendAgreementSms(id));

      if (resultAction.meta.requestStatus === "fulfilled") {
        toggle();
      }
    } catch (error) {
      console.error("Failed:", error);
    }
  };

  return (
    <Modal size="md" isOpen={isOpen} toggle={toggle} centered>
      <ModalHeader
        className="modal-title "
        id="myLargeModalLabel"
        toggle={toggle}
      >
        SMS Gönder
      </ModalHeader>

      <ModalBody className="text-center text-dark">
        <img
          src={Question}
          alt="SMS Question"
          id="candidate-img"
          className="img-fluid mb-4"
          style={{ height: "80px" }}
        />
        <h4 className="text-dark">Sözleşme örneği SMS olarak iletilsin mi?</h4>
        <div className="d-flex align-items-center gap-3 mt-5 justify-content-center">
          <Button
            className="btn btn-sm"
            color="primary"
            disabled={resendAgreementSmsLoading}
            onClick={sendSMS}
          >
            Onayla
          </Button>
        </div>
      </ModalBody>
    </Modal>
  );
};

export default AgreementSmsModal;
